import React, { useEffect, useState } from 'react';
import { Link, useRouteMatch } from 'react-router-dom';
import { CDN_TYPE_CMS, imageUrlCDN } from 'utils';

import { PromotionCard } from '@atlas/components';
import { getPromotion, isEmptyObject, SiteConfigManager, useSettings } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Button, Icon } from '@atlas/ui';

import SeoPageText from 'src/components/SeoPage/SeoPageText';

import PromotionDetailsSkeleton from './PromotionDetailsSkeleton';
import HeaderSkeleton from './PromotionHeaderSkeleton';

const PromotionDetails = () => {
  const {
    params: { id },
  } = useRouteMatch();
  const promotionsURL = SiteConfigManager.getComponentPath(COMPONENT_TYPES.PROMOTIONS);
  const { lang } = useSettings();

  const [DOMPurify, installDOMPurify] = useState({});
  const [promotion, setPromotion] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    import('dompurify').then(DOMPurifyModule => {
      installDOMPurify({ ...DOMPurifyModule.default });
    });
  }, []);

  useEffect(() => {
    getPromotion(id)
      .then(data => {
        if (isEmptyObject(data)) {
          throw new Error('Promotion not found');
        }
        setPromotion(data);
      })
      .catch(() => {
        setPromotion({});
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, lang]);

  return (
    <div className="layout-to-scroll">
      <div className="promotion_page single">
        <div className="promotion promotion-details-wrapper">
          {loading ? (
            <>
              <Icon className="icon-back icon-back-skeleton" name="back" />
              <HeaderSkeleton loading={loading}>
                <Link className="back-to-container ellipsis" to={promotionsURL}>
                  <Icon className="icon-back" name="back" />
                  <span className="title-text">{promotion.title}</span>
                </Link>
              </HeaderSkeleton>
            </>
          ) : (
            <Link className="back-to-container ellipsis" to={promotionsURL}>
              <Icon className="icon-back" name="back" />
              <h1 className="title-text">{promotion.title}</h1>
            </Link>
          )}
          <PromotionDetailsSkeleton loading={loading}>
            <div className="content static_page">
              <div>
                <PromotionCard
                  description={promotion.description}
                  imageUrl={imageUrlCDN(promotion.cover_image_url, CDN_TYPE_CMS)}
                  isMobile
                  isPromotionChosen
                  key={id}
                  layoutType={promotion.layout}
                />
              </div>
              {!!DOMPurify.sanitize && (
                <>
                  <div
                    className="description short-content"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(promotion.short_content, { KEEP_CONTENT: true }),
                    }}
                  />
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(promotion.full_content, { FORCE_BODY: true }),
                    }}
                  />
                </>
              )}
            </div>
          </PromotionDetailsSkeleton>
        </div>
        {promotion?.link && (
          <div className="promotion-details-link-wrapper">
            <Link className="promotion-details-link" to={promotion.link}>
              <Button label={promotion?.button || 'promo_button_empty'} size="big" type="primary" />
            </Link>
          </div>
        )}
      </div>
      <SeoPageText />
    </div>
  );
};

export default PromotionDetails;
